import { useContext } from 'react'
import { DeviceHttpProxyContext } from '../contexts'

export const useDeviceHttpProxyContext = () =>
  useContext(DeviceHttpProxyContext)
